// ▶ Quais tabelas de preço a ficha do produto oferece no seletor VISUALIZANDO.
//
// Achado dela no primeiro teste real, 03/09/2026: o produto 1010 (Forma
// Ballerine Luna) só tem preço em 2 das 4 tabelas da Forte Pan, e o seletor
// mostrava as 4. Editando continua mostrando todas -- é por ali que se
// adiciona o produto a uma tabela nova.
export function tabelasVisiveisNaFicha<T extends { id: string }>(
  tabelas: T[],
  precosDoProduto: { tabela_preco_id: string; preco?: number | null }[],
): T[] {
  // `!= null` de propósito, pela mesma razão de sempre: uma linha de `precos`
  // pode existir com `preco` nulo (avulso isolado, sujeira de import), e isso
  // não é "o produto existe nesta tabela".
  const comPreco = new Set(
    precosDoProduto.filter((p) => p.preco != null).map((p) => p.tabela_preco_id),
  )
  return tabelas.filter((t) => comPreco.has(t.id))
}
